import ParentModal from '../models/parentModal.es6';
import ParentModalView from '../views/parentModalView.es6';

export default class ParentModalController {
    constructor() {
        this.parentModal = new ParentModal();
        this.parentModalView = new ParentModalView();
    }

    openParentModal() {
        const event = new CustomEvent('openParentModal');

        const handleOpenParentModal = (el) => {
            // 再生が終わってからカスタムイベントを発行
            document.dispatchEvent(event);
        };

        this.parentModalView.openBtn.addEventListener('click', handleOpenParentModal);
    }

    closeParentModal() {
        const event = new CustomEvent('closeParentModal');

        const handleCloseParentModal = (el) => {
            // 再生が終わってからカスタムイベントを発行
            document.dispatchEvent(event);
        };

        this.parentModalView.closeBtn.addEventListener('click', handleCloseParentModal);
    }
}
